import { IndexedDb } from "@/services/indexedDb";
import { type UserToken } from "@/services/user/types";

/**
 * Handles token storing and retrieval in/from browser.
 */
export const TokenService = {
  DatabaseKey: "userToken",

  get: async (): Promise<UserToken | null> => {
    return IndexedDb.get(TokenService.DatabaseKey);
  },

  store: (token: UserToken): void => {
    IndexedDb.set(TokenService.DatabaseKey, token);
  },

  delete: (): void => {
    IndexedDb.delete(TokenService.DatabaseKey);
  },
};
